<template>
  <div class="ev-wrap">
    <ProgressBar v-if="loader" mode="indeterminate"
      style="height:3px;position:fixed;top:0;left:0;right:0;z-index:9999;border-radius:0"/>

    <!-- ══ Estado: sin app Seway ══ -->
    <template v-if="!seway_exist">
      <div class="ev-empty-app">
        <img src="layout/images/widgets/feature-faq.svg" alt="Sin app" style="width:280px;margin-bottom:1.5rem"/>
        <h3 class="ev-empty-title">Su empresa no cuenta con Seway-plus</h3>
        <p class="ev-empty-sub">Contáctese con un comercial para activar la aplicación móvil.</p>
        <a href="https://wa.link/8ppwru" target="_blank">
          <button class="ev-btn-whatsapp">
            <i class="pi pi-whatsapp"></i> Contactar comercial
          </button>
        </a>
      </div>
    </template>

    <!-- ══ Vista principal ══ -->
    <template v-else>

      <!-- ── Topbar ── -->
      <div class="ev-topbar">
        <div>
          <h2 class="ev-title">Configuración de Eventos</h2>
          <p class="ev-sub">Gestión de tipos de despacho y eventos por generador</p>
        </div>
        <div class="ev-topbar-actions">
          <button class="ev-btn-outline" @click="toggle">
            <i class="pi pi-filter"></i> Filtrar
          </button>
          <button class="ev-btn-orange" @click="openModalMasiv">
            <i class="pi pi-wrench"></i> Configuración masiva
          </button>
        </div>
      </div>

      <!-- ── Panel filtros ── -->
      <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" :style="{width:'520px'}">
        <div class="ev-filtros">
          <div class="ev-filtros-title"><i class="pi pi-filter"></i> Filtrar generadores</div>
          <div class="ev-filtros-field">
            <label>Generador</label>
            <Multiselect v-model="selectgenerador" placeholder="Buscar generador…"
              :max="-1" valueProp="documento" :options="generadores"
              :searchable="true" label="nombre" track-by="nombre"
              @click="traerindicadores(selectgenerador)" />
          </div>
          <div class="ev-filtros-actions">
            <button class="ev-btn-outline" @click="limpiar">
              <i class="pi pi-filter-slash"></i> Limpiar
            </button>
          </div>
        </div>
      </OverlayPanel>

      <!-- ── Tabla generadores ── -->
      <div class="ev-tabla-wrap">
        <table class="ev-tabla">
          <thead>
            <tr>
              <th>NIT</th>
              <th>Generador</th>
              <th style="width:140px;text-align:center">Estado config.</th>
              <th style="width:90px;text-align:center">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="generadores_table.length === 0 && !loader">
              <td colspan="4" class="ev-empty">
                <i class="pi pi-building"></i>
                <p>No se encontraron generadores</p>
              </td>
            </tr>
            <tr v-for="(gen, i) in generadores_table" :key="i">
              <td>
                <span class="ev-nit">{{ gen.documento }}</span>
              </td>
              <td>
                <div class="ev-gen-name">{{ gen.razon_social }}</div>
              </td>
              <td style="text-align:center">
                <span v-if="generadores_seway.find(gs => gs.id_client == gen.documento)"
                      class="ev-badge ev-badge--verde">
                  <i class="pi pi-check" style="font-size:.6rem"></i> Configurado
                </span>
                <span v-else class="ev-badge ev-badge--naranja">
                  <i class="pi pi-exclamation-triangle" style="font-size:.6rem"></i> Sin configurar
                </span>
              </td>
              <td style="text-align:center">
                <button class="ev-btn-icon" title="Configurar eventos"
                        @click="openModalConfig(gen)" :disabled="loader_table">
                  <i class="pi pi-file-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <template v-if="loader && generadores_table.length === 0">
          <div class="ev-skeleton-wrap">
            <div v-for="n in 5" :key="n" class="ev-skeleton-row"></div>
          </div>
        </template>

        <div class="ev-pagination">
          <span>{{ pagination.from }}–{{ pagination.to }} de {{ pagination.total }} generadores</span>
          <Paginator :v-model:first="pagination.from" :rows="pagination.per_page"
            :rowsPerPageOptions="[15]" :totalRecords="pagination.total"
            @page="onChangePage($event)" class="ev-paginator" />
        </div>
      </div>

    </template>

    <!-- ══ MODAL: Tipos de despacho ══ -->
    <Dialog v-model:visible="modal_config" :style="{width:'440px'}"
            header="Tipos de despacho" :modal="true" class="ev-dialog">
      <div class="ev-modal-body">
        <div class="ev-info-msg">
          <i class="pi pi-info-circle"></i>
          Seleccione los tipos de despacho que desea configurar para este generador.
        </div>
        <div class="ev-check-all">
          <Checkbox id="chkAll" :binary="true" v-model="checkboxAlltypos"
            @click="checked_all_tipo_despacho" />
          <label for="chkAll">Seleccionar todos</label>
        </div>
        <div class="ev-tipos-lista">
          <div v-for="(td, i) in tipos_despachos" :key="i"
               :class="['ev-tipo-item', checkboxValue && checkboxValue.find(c => c.idtipo_despachos == td.idtipo_despachos) ? 'ev-tipo-item--on' : '']">
            <Checkbox :id="'td_'+i" name="tipo" :value="valor_check(td)" v-model="checkboxValue" />
            <label :for="'td_'+i" class="ev-tipo-label">{{ td.descripcion }}</label>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ev-btn-outline" @click="modal_config = false">
          <i class="pi pi-times"></i> Cerrar
        </button>
        <button class="ev-btn-primary"
          :disabled="!checkboxValue || checkboxValue.length === 0 || loader_even"
          @click="showEvents">
          <i class="pi pi-arrow-right"></i> Siguiente
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Eventos por tipo de despacho ══ -->
    <Dialog v-model:visible="modal_events" :style="{width:'92vw',maxWidth:'1400px'}"
            :modal="true" class="ev-dialog ev-dialog--wide">
      <template #header>
        <div class="ev-modal-events-header">
          <div>
            <div class="ev-modal-events-title">Eventos en tipos de despacho</div>
            <div class="ev-modal-events-sub">Configure los eventos para cada tipo seleccionado</div>
          </div>
          <button v-if="openpermisionmasiv()" class="ev-btn-outline" @click="openModalEventsMasiv">
            <i class="pi pi-plus"></i> Crear eventos masivos
          </button>
        </div>
      </template>

      <div class="ev-eventos-container">
        <div v-for="(evento, index) in eventos" :key="index" class="ev-evento-bloque">

          <!-- Header del bloque -->
          <div class="ev-bloque-header">
            <div class="ev-bloque-left">
              <div class="ev-bloque-icon"><i class="pi pi-truck"></i></div>
              <div>
                <div class="ev-bloque-title">{{ evento.tipo_despacho }}</div>
                <div class="ev-bloque-sub">{{ evento.eventos.length }} evento(s) configurado(s)</div>
              </div>
            </div>
            <div class="ev-bloque-actions">
              <span :class="['ev-badge',
                evento.estado_tipo_despacho ? 'ev-badge--verde' : 'ev-badge--naranja']">
                <i :class="evento.estado_tipo_despacho ? 'pi pi-check' : 'pi pi-exclamation-triangle'"
                   style="font-size:.6rem"></i>
                {{ evento.estado_tipo_despacho ? 'Guardado' : 'Sin guardar' }}
              </span>
              <template v-if="evento.contain">
                <template v-if="evento.editable">
                  <button class="ev-btn-sm ev-btn-sm--primary" @click="openModalEents(evento, index)">
                    <i class="pi pi-plus"></i> Agregar
                  </button>
                  <button class="ev-btn-sm ev-btn-sm--success" @click="confirmarEventsTipoDespacho(evento, index)" :disabled="loader_even">
                    <i class="pi pi-check"></i> Confirmar
                  </button>
                </template>
                <template v-else>
                  <button class="ev-btn-icon" title="Editar" @click="evento.editable = true">
                    <i class="pi pi-pencil"></i>
                  </button>
                </template>
              </template>
              <template v-else>
                <button class="ev-btn-sm ev-btn-sm--primary" @click="openModalEents(evento, index)">
                  <i class="pi pi-plus"></i> Agregar evento
                </button>
              </template>
              <button class="ev-btn-icon ev-btn-icon--danger" title="Eliminar tipo despacho"
                      @click="openModalDeleteTipoDespacho(evento, index)">
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </div>

          <!-- Tabla de eventos del bloque -->
          <div class="ev-tabla-wrap" style="margin:0;border-radius:0 0 12px 12px;border-top:none">
            <div style="overflow-x:auto">
              <table class="ev-tabla ev-tabla--events">
                <thead>
                  <tr>
                    <th>Evento</th>
                    <th style="width:70px;text-align:center">Seq.</th>
                    <th style="width:110px;text-align:center">Fotos perm.</th>
                    <th style="width:110px;text-align:center">Fotos oblig.</th>
                    <th style="width:90px;text-align:center">Tiempo</th>
					<span
						title="Ingrese el valor en minutos"
						style="
							display:inline-block;
							width:16px;
							height:16px;
							line-height:16px;
							text-align:center;
							border-radius:50%;
							background:#6c757d;
							color:white;
							font-size:12px;
							cursor:help;
							margin-left:4px;
						">
						?
					</span>
                    <th style="width:90px;text-align:center">Confirm.</th>
                    <th style="width:100px;text-align:center">Auto GPS
						<span
							title="Ingrese el valor en minutos"
							style="
								display:inline-block;
								width:16px;
								height:16px;
								line-height:16px;
								text-align:center;
								border-radius:50%;
								background:#6c757d;
								color:white;
								font-size:12px;
								cursor:help;
								margin-left:4px;
							">
							?
						</span>
					</th>
                    <th style="width:90px;text-align:center">Geocerca</th>
                    <th style="width:90px;text-align:center">Automático</th>
                    <th style="width:100px;text-align:center">Permanencia
						<span
							title="Ingrese el valor en minutos"
							style="
								display:inline-block;
								width:16px;
								height:16px;
								line-height:16px;
								text-align:center;
								border-radius:50%;
								background:#6c757d;
								color:white;
								font-size:12px;
								cursor:help;
								margin-left:4px;
							">
							?
						</span>
					</th>
                    <th style="width:100px;text-align:center">Estado</th>
                    <th v-if="evento.editable" style="width:70px;text-align:center">Acc.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="evento.eventos.length === 0">
                    <td :colspan="evento.editable ? 12 : 11" class="ev-empty" style="padding:1.5rem !important">
                      <i class="pi pi-calendar-times"></i>
                      <p>Sin eventos — usa "Agregar evento" para comenzar</p>
                    </td>
                  </tr>
                  <tr v-for="(ev, ei) in evento.eventos" :key="ei">
                    <td><span class="ev-event-name">{{ ev.event }}</span></td>
                    <td style="text-align:center"><span class="ev-seq">{{ ev.sequence }}</span></td>
                    <td style="text-align:center">
                      <InputNumber v-if="evento.editable" v-model="ev.photo_numbers"
                        :min="0" :max="100" class="ev-input-num" />
                      <span v-else class="ev-num">{{ ev.photo_numbers }}</span>
                    </td>
                    <td style="text-align:center">
                      <InputNumber v-if="evento.editable" v-model="ev.photo_required"
                        :min="0" :max="100" class="ev-input-num" />
                      <span v-else class="ev-num">{{ ev.photo_required }}</span>
                    </td>
                    <td style="text-align:center">
                      <InputNumber v-if="evento.editable" v-model="ev.time"
                        :min="0" :max="1440" class="ev-input-num" />
                      <span v-else class="ev-num">{{ ev.time }}</span>
                    </td>
                    <td style="text-align:center">
                      <Checkbox :binary="true" v-model="ev.confirmation"
                        :disabled="!evento.editable" />
                    </td>
                    <td style="text-align:center">
                      <InputNumber v-if="evento.editable" v-model="ev.auto_correction_minutes"
                        :min="0" :max="1440" class="ev-input-num" />
                      <span v-else class="ev-num">{{ ev.auto_correction_minutes ?? '—' }}</span>
                    </td>
                    <td style="text-align:center">
                      <Checkbox :binary="true" v-model="ev.validate_geocerca"
                        :disabled="!evento.editable" />
                    </td>
                    <td style="text-align:center">
                      <Checkbox :binary="true" v-model="ev.allow_automatic"
                        :disabled="!evento.editable" />
                    </td>
                    <td style="text-align:center">
                      <InputNumber v-if="evento.editable" v-model="ev.dwell_time_minutes"
                        :min="0" :max="1440" class="ev-input-num" />
                      <span v-else class="ev-num">{{ ev.dwell_time_minutes }}</span>
                    </td>
                    <td style="text-align:center">
                      <span :class="['ev-badge', ev.id == 0 ? 'ev-badge--naranja' : 'ev-badge--verde']">
                        {{ ev.id == 0 ? 'Sin guardar' : 'Guardado' }}
                      </span>
                    </td>
                    <td v-if="evento.editable" style="text-align:center">
                      <button v-if="ev.id_events != 5"
                        class="ev-btn-icon ev-btn-icon--danger" title="Eliminar evento"
                        @click="eliminar_evento(ev, ei, index)">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="eventos.length === 0" class="ev-empty" style="padding:3rem">
          <i class="pi pi-calendar-times"></i>
          <p>No hay tipos de despacho seleccionados</p>
        </div>
      </div>

      <template #footer>
        <button class="ev-btn-outline" @click="modal_events = false; modal_config = true">
          <i class="pi pi-arrow-left"></i> Anterior
        </button>
        <button class="ev-btn-primary" :disabled="!checkboxValue || loader_even"
                @click="guardar_eventos">
          <i class="pi pi-save"></i> Guardar eventos
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Seleccionar eventos ══ -->
    <Dialog v-model:visible="modal_eventos" :style="{width:'440px'}"
            header="Seleccionar eventos" :modal="true" class="ev-dialog">
      <div class="ev-modal-body">
        <div v-if="openmasiv" class="ev-warn-msg">
          <i class="pi pi-exclamation-triangle"></i>
          Los eventos seleccionados se aplicarán a TODOS los tipos de despacho
          <strong>sin guardar</strong>.
        </div>
        <div class="ev-eventos-check-lista">
          <div v-for="(ev, i) in list_events.todos_eventos" :key="i"
               :class="['ev-check-item',
                 checkEvents && checkEvents.find(c => c.id_events == ev.id_events) ? 'ev-check-item--on' : '']">
            <Checkbox :id="'ev_'+i" name="event" :value="ev" v-model="checkEvents"
              :disabled="ev.id_events == 5" />
            <label :for="'ev_'+i" class="ev-check-label">
              <i class="pi pi-calendar" style="font-size:.72rem;margin-right:.35rem"></i>
              {{ ev.event }}
            </label>
            <span v-if="ev.id_events == 5" class="ev-badge ev-badge--azul">Requerido</span>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ev-btn-outline"
                @click="modal_eventos = false; modal_events = true">
          <i class="pi pi-times"></i> Cerrar
        </button>
        <button v-if="checkEvents && checkEvents.length > 0"
                class="ev-btn-primary"
                @click="openmasiv ? selectedEventsMasiv() : selectedEvents()">
          <i class="pi pi-check"></i> {{ openmasiv ? 'Listo masivo' : 'Listo' }}
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Configuración masiva (tabla grande) ══ -->
    <Dialog v-model:visible="modal_events_masiv"
            :style="{width:'92vw',maxWidth:'1400px'}" :modal="true" class="ev-dialog ev-dialog--wide">
      <template #header>
        <div class="ev-modal-events-header">
          <div>
            <div class="ev-modal-events-title">Configuración masiva para generadores</div>
            <div class="ev-modal-events-sub">
              Los valores aquí definidos se aplicarán a todos los generadores como base
            </div>
          </div>
        </div>
      </template>
      <div style="overflow-x:auto">
        <table class="ev-tabla ev-tabla--events">
          <thead>
            <tr>
              <th style="width:80px;text-align:center">Activo</th>
              <th>Evento</th>
              <th style="width:70px;text-align:center">Seq.</th>
              <th style="width:110px;text-align:center">Fotos perm.</th>
              <th style="width:110px;text-align:center">Fotos oblig.</th>
              <th style="width:90px;text-align:center">Tiempo
				<span
					title="Ingrese el valor en minutos"
					style="
						display:inline-block;
						width:16px;
						height:16px;
						line-height:16px;
						text-align:center;
						border-radius:50%;
						background:#6c757d;
						color:white;
						font-size:12px;
						cursor:help;
						margin-left:4px;
					">
					?
				</span>
			  </th>
              <th style="width:90px;text-align:center">Confirm.</th>
              <th style="width:100px; text-align:center;">
					Auto GPS
					<span
						title="Ingrese el valor en minutos"
						style="
							display:inline-block;
							width:16px;
							height:16px;
							line-height:16px;
							text-align:center;
							border-radius:50%;
							background:#6c757d;
							color:white;
							font-size:12px;
							cursor:help;
							margin-left:4px;
						">
						?
					</span>
			  </th>
              <th style="width:90px;text-align:center">Geocerca</th>
              <th style="width:90px;text-align:center">Automático</th>
              <th style="width:100px;text-align:center">Permanencia
				<span
					title="Ingrese el valor en minutos"
					style="
						display:inline-block;
						width:16px;
						height:16px;
						line-height:16px;
						text-align:center;
						border-radius:50%;
						background:#6c757d;
						color:white;
						font-size:12px;
						cursor:help;
						margin-left:4px;
					">
					?
				</span>
			  </th>
              <th style="width:100px;text-align:center">Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ev, i) in json_events_masiv" :key="i"
                :class="{'ev-row--inactive': !ev.available}">
              <td style="text-align:center">
                <Checkbox :binary="true" v-model="ev.available"
                  :disabled="ev.id_events == 5" />
              </td>
              <td><span class="ev-event-name">{{ ev.event }}</span></td>
              <td style="text-align:center"><span class="ev-seq">{{ ev.sequence }}</span></td>
              <td style="text-align:center">
                <InputNumber v-if="ev.available" v-model="ev.photo_numbers"
                  :min="0" :max="100" class="ev-input-num" />
                <span v-else class="ev-num ev-num--dim">{{ ev.photo_numbers }}</span>
              </td>
              <td style="text-align:center">
                <InputNumber v-if="ev.available" v-model="ev.photo_required"
                  :min="0" :max="100" class="ev-input-num" />
                <span v-else class="ev-num ev-num--dim">{{ ev.photo_required }}</span>
              </td>
              <td style="text-align:center">
                <InputNumber v-if="ev.available" v-model="ev.time"
                  :min="0" :max="1440" class="ev-input-num" />
                <span v-else class="ev-num ev-num--dim">{{ ev.time }}</span>
              </td>
              <td style="text-align:center">
                <Checkbox :binary="true" v-model="ev.confirmation"
                  :disabled="!ev.available" />
              </td>
              <td style="text-align:center">
                <InputNumber v-if="ev.available" v-model="ev.auto_correction_minutes"
                  :min="0" :max="1440" class="ev-input-num" />
                <span v-else class="ev-num ev-num--dim">—</span>
              </td>
              <td style="text-align:center">
                <Checkbox :binary="true" v-model="ev.validate_geocerca"
                  :disabled="!ev.available" />
              </td>
              <td style="text-align:center">
                <Checkbox :binary="true" v-model="ev.allow_automatic"
                  :disabled="!ev.available" />
              </td>
              <td style="text-align:center">
                <InputNumber v-if="ev.available" v-model="ev.dwell_time_minutes"
                  :min="0" :max="1440" class="ev-input-num" />
                <span v-else class="ev-num ev-num--dim">{{ ev.dwell_time_minutes }}</span>
              </td>
              <td style="text-align:center">
                <span :class="['ev-badge', ev.id == 0 ? 'ev-badge--naranja' : 'ev-badge--verde']">
                  {{ ev.id == 0 ? 'Sin guardar' : 'Guardado' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <button class="ev-btn-outline" @click="modal_events_masiv = false">
          <i class="pi pi-times"></i> Cerrar
        </button>
        <button v-if="checkEventsMasiv" class="ev-btn-primary"
                :disabled="loader_even" @click="guardar_events_default">
          <i class="pi pi-save"></i> Guardar configuración
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Confirmar eliminar evento ══ -->
    <Dialog v-model:visible="deleteEventDialog" :style="{width:'420px'}"
            header="Eliminar evento" :modal="true" class="ev-dialog">
      <div class="ev-modal-body">
        <div class="ev-confirm-body">
          <div class="ev-confirm-icon ev-confirm-icon--danger">
            <i class="pi pi-trash"></i>
          </div>
          <div>
            <p class="ev-confirm-q">¿Eliminar este evento?</p>
            <p class="ev-confirm-sub">Puedes volver a agregarlo en cualquier momento.</p>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ev-btn-outline" @click="deleteEventDialog = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="ev-btn-danger" :disabled="loader_even" @click="deleteEvent">
          <i class="pi pi-trash"></i> Eliminar
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Confirmar eliminar tipo de despacho ══ -->
    <Dialog v-model:visible="deleteTipoDespachoDialog" :style="{width:'440px'}"
            header="Eliminar tipo de despacho" :modal="true" class="ev-dialog">
      <div class="ev-modal-body">
        <div class="ev-confirm-body">
          <div class="ev-confirm-icon ev-confirm-icon--danger">
            <i class="pi pi-trash"></i>
          </div>
          <div>
            <p class="ev-confirm-q">¿Eliminar este tipo de despacho?</p>
            <p class="ev-confirm-sub">
              Se eliminarán también todos los eventos asociados. Esta acción no se puede deshacer.
            </p>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ev-btn-outline" @click="deleteTipoDespachoDialog = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="ev-btn-danger" :disabled="loader_even" @click="deleteEventTipoDespach">
          <i class="pi pi-trash"></i> Eliminar
        </button>
      </template>
    </Dialog>

    <!-- ══ MODAL: Confirmar eliminar evento masivo ══ -->
    <Dialog v-model:visible="deleteEventDialogMasiv" :style="{width:'420px'}"
            header="Eliminar evento masivo" :modal="true" class="ev-dialog">
      <div class="ev-modal-body">
        <div class="ev-confirm-body">
          <div class="ev-confirm-icon ev-confirm-icon--danger">
            <i class="pi pi-trash"></i>
          </div>
          <div>
            <p class="ev-confirm-q">¿Eliminar este evento masivo?</p>
            <p class="ev-confirm-sub">Puedes volver a configurarlo en cualquier momento.</p>
          </div>
        </div>
      </div>
      <template #footer>
        <button class="ev-btn-outline" @click="deleteEventDialogMasiv = false">
          <i class="pi pi-times"></i> Cancelar
        </button>
        <button class="ev-btn-danger" :disabled="loader_even" @click="deleteEventMasiv">
          <i class="pi pi-trash"></i> Eliminar
        </button>
      </template>
    </Dialog>

  </div>
</template>

<script>
// import axios from 'axios'
export default {
	data() {
		return {
			message: [],
			customers: [],
			generadores_seway: [],
			tipos_despachos: [],
			list_tdespachos_selected: [],
			loader_table_event: false,
			generadores_table: [],
			username:null,
			rowsPerPage: 15, // Número de filas por página
			currentPage: 1, // Página actual
			totalRows: 0, 
			selectgenerador: null,
			seway_exist: false,
			deleteEventDialog: false,
			deleteEventDialogMasiv: false,
			deleteTipoDespachoDialog: false,
			loader_table: false,
			modal_eventos: false,
			editable_masiv: false,
			checkboxAlltypos: false,
			generadores: [],
			list_events: [],
			eventos_configurados_masiv: [],
			events_default: [],
			loader: false,
			openmasiv: false,
			modal_eventos_masiv: false,
			modalAmplio: '1100px',
            modalResponsive: '90vw',
			loader_gen: false,
			loader_even: false,
			modal_config: false,
			modal_events: false,
			modal_events_masiv: false,
			json_events_masiv: [],
			email:null,
			checkboxValue:null,
			checkEvents:null,
			checkEventsMasiv:null,
			eventos: [],
			nit_generador: '',
			select_events: [],
			paginador_mas_90: {},
			paginador_61a90: {},
			paginador_31a60: {},
			paginador_0a30: {},
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			count: 0,
			selectedProducts: [],
			items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
			ingresoCostumer: false
		}
	},
	mounted(){
		this.loadGeneradores(1);
		// this.cargargeneradorescustomer(1);
	},
	methods:{
		toggle(event) {
			this.$refs.op.toggle(event);
		},
		paginate(event) {
			this.currentPage = event.page + 1;
			this.loadGeneradores(this.currentPage);
		},
		openModalMasiv(){
			// this.modal_eventos_masiv = true;
			// this.checkEventsMasiv = [];
			// this.eventos_configurados_masiv.forEach(element => {
			// 	this.checkEventsMasiv.push({
			// 		id_events: element.id_events
			// 	});
			// });
			
			// console.log(this.checkEventsMasiv);
			// console.log(this.eventos_configurados_masiv);
			this.json_events_masiv = [];
			var i = 0;

			this.eventos_configurados_masiv.forEach(element => {
						i = i+1;
						// var ev_seway =  this.eventos_configurados_masiv.find((event_seway) => event_seway.id_events == element.id_events)
						var def_event =  this.events_default.find((event_def) => event_def.id_events == element.id_events)
						
						if (def_event!=null) {
							var id_default = def_event.id;
							var photo_numbers = def_event.photo_numbers;
							var photo_required = def_event.photo_required;
							var time = def_event.time;
							var available = def_event.available;
							var auto_correction_minutes = def_event.auto_correction_minutes;
							var dwell_time_minutes = def_event.dwell_time_minutes;
							// var confirmation = def_event.confirmation;
							if (def_event.confirmation == 1) {
								var confirmation = true;
							}else{
								var confirmation = 0;
							}
							if (def_event.validate_geocerca == 1) {
								var validate_geocerca = true;
							}else{
								var validate_geocerca = 0;
							}
							if (def_event.allow_automatic == 1) {
								var allow_automatic = true;
							}else{
								var allow_automatic = 0;
							}
						}else{
							// console.log(ev_seway);
							var id_default = 0;
							var photo_numbers = 0;
							var photo_required = 0;
							var time = 0;
							var confirmation = 0;
							var auto_correction_minutes = null;
							var validate_geocerca = 0;
							var allow_automatic = 0;
							var dwell_time_minutes = 5;
							if (element.id_events == 5) {
								var available = true;
							}else{
								var available = 0;
							}
							
						}
							// if (ev_seway!=null) {
								this.json_events_masiv.push({
									code: element.code,
									available: available,
									event: element.event,
									id: id_default,
									// id_default: def_event.id ?? 0,
									id_events: element.id_events,
									photo_numbers: photo_numbers,
									photo_required: photo_required,
									sequence: i,
									time: time,
									confirmation: confirmation,
									auto_correction_minutes: auto_correction_minutes,
									validate_geocerca: validate_geocerca,
									allow_automatic: allow_automatic,
									dwell_time_minutes: dwell_time_minutes,
									types_dispatches_clients_id: 0,
									editable: false
								});
							// }
					});

			this.json_events_masiv = this.json_events_masiv.sort((a, b) => a.id_events - b.id_events);
			var i = 0
			this.json_events_masiv.forEach(element => {
					i = i+1;
					element.sequence = i;
				});

			this.modal_eventos_masiv = false;
			this.modal_events_masiv = true;
		},
			// Función para cargar los datos de la tabla
		loadGeneradores(page) {
		// Lógica para cargar los datos de la tabla
		this.cargargeneradorescustomer(page);

		},
		showSuccess(customer,index) {

			document.cookie = "NameCustomer="+customer.name;
			document.cookie = "IdCustomer="+customer.id_customer;
			document.cookie = "UrlImgCustomer="+customer.url;
			document.cookie = "IdUsuarioRol="+customer.id;
			this.ingresoCostumer = true;
			
			this.$router.push({ path: this.$store.getters['infoNavigation/Rol']+'/inicio'});
		},
		valor_check(data){
			return {
						idtipo_despachos: data.idtipo_despachos ?? 0,
						// id: data.id ?? 0,
						descripcion: data.descripcion ?? 0,
						seway_tdespacho: data.seway_tdespacho ?? 0
					}
		},
		valor_check_evento(data){
			return {
						id_events: data.id_events ?? 0
					}
		},
		checked_all_tipo_despacho(){
			var i = 0
			if (this.checkboxAlltypos==false) {
				
				// console.log(i);
				// console.log(this.tipos_despachos);
				this.tipos_despachos.forEach(element => {
					i = i+1;
					this.checkboxValue[i] = {
						idtipo_despachos: element.idtipo_despachos,
						descripcion: element.descripcion,
						seway_tdespacho: element.seway_tdespacho
					}
				});
			}else{
				
					this.checkboxValue = [];
			}
		},
		selectedEvents(){
			// console.log(this.checkEvents);
			this.modal_eventos = false;
			this.modal_events = true;
			var i = 0
			
			this.eventos[this.list_events.index].contain = true;
			this.checkEvents = this.checkEvents.sort((a, b) => a.id_events - b.id_events);

			this.checkEvents.forEach(element => {
				i = i+1;
				// if (condition) {
					
				// }
				var ev_seway =  this.eventos[this.list_events.index].eventos.find((event_seway) => event_seway.code == element.code)
				// console.log(ev_seway);
					if (ev_seway==null) {
						this.eventos[this.list_events.index].eventos.push({
							code: element.code,
							event: element.event,
							id: element.id ?? 0,
							id_events: element.id_events,
							photo_numbers: 0,
							photo_required: 0,
							sequence: i,
							time: 0,
							auto_correction_minutes: null,
							allow_automatic: 0,
							validate_geocerca: 0,
							dwell_time_minutes: 5,
							confirmation: 0,
							types_dispatches_clients_id: 0
						});
					}else{
						ev_seway.sequence = i;
					}
					
			});

			this.eventos[this.list_events.index].eventos = this.eventos[this.list_events.index].eventos.sort((a, b) => a.id_events - b.id_events);
			var i = 0
			this.eventos[this.list_events.index].eventos.forEach(element => {
				i = i+1;
				// console.log('Se cambia '+element.sequence+' por '+i);
				element.sequence = i;
			});
		},
		selectedEventsMasiv(){
			// console.log(this.checkEvents);
			// console.log(this.eventos);
			
			this.eventos.forEach(evento => {
				var i = 0
				// console.log(evento);
				if (evento.estado_tipo_despacho == false) {

					evento.contain = true;
					evento.eventos = [];
					this.checkEvents.forEach(element => {
						i = i+1;
						// console.log(evento);
						evento.eventos.push({
							code: element.code,
							event: element.event,
							id: element.id ?? 0,
							id_events: element.id_events,
							photo_numbers: 0,
							photo_required: 0,
							sequence: i,
							time: 0,
							confirmation: 0,
							types_dispatches_clients_id: 0
						});
					});
				}

				evento.eventos = evento.eventos.sort((a, b) => a.id_events - b.id_events);
				var i = 0
				evento.eventos.forEach(element => {
						i = i+1;
						// console.log('Se cambia '+element.sequence+' por '+i);
						element.sequence = i;
					});


			});
			this.modal_eventos = false;
			this.modal_events = true;
		},
		saveEventsMasiv(){
			this.json_events_masiv = [];
			var i = 0;

			this.checkEventsMasiv.forEach(element => {
						i = i+1;
						var ev_seway =  this.eventos_configurados_masiv.find((event_seway) => event_seway.id_events == element.id_events)
						var def_event =  this.events_default.find((event_def) => event_def.id_events == element.id_events)
						
						if (def_event!=null) {
							var id_default = def_event.id;
							var photo_numbers = def_event.photo_numbers;
							var photo_required = def_event.photo_required;
							var time = def_event.time;
							var auto_correction_minutes = def_event.auto_correction_minutes;
							var validate_geocerca = def_event.validate_geocerca;
							var allow_automatic = def_event.allow_automatic;
							var dwell_time_minutes = def_event.dwell_time_minutes;
							var available = def_event.available;
							var confirmation = def_event.confirmation;
						}else{
							// console.log(ev_seway);
							var id_default = 0;
							var photo_numbers = 0;
							var photo_required = 0;
							var time = 0;
							var auto_correction_minutes = null;
							var validate_geocerca = 0;
							var allow_automatic = 0;
							var dwell_time_minutes = 5;
							var available = 0;
							var confirmation = 0;
						}
							if (ev_seway!=null) {
								this.json_events_masiv.push({
									code: ev_seway.code,
									available: available,
									event: ev_seway.event,
									id: id_default,
									// id_default: def_event.id ?? 0,
									id_events: ev_seway.id_events,
									photo_numbers: photo_numbers,
									photo_required: photo_required,
									sequence: i,
									time: time,
									auto_correction_minutes: auto_correction_minutes,
									validate_geocerca: validate_geocerca,
									allow_automatic: allow_automatic,
									dwell_time_minutes: dwell_time_minutes,
									confirmation: confirmation,
									types_dispatches_clients_id: 0,
									editable: false
								});
							}
					});

			this.json_events_masiv = this.json_events_masiv.sort((a, b) => a.id_events - b.id_events);
			var i = 0
			this.json_events_masiv.forEach(element => {
					i = i+1;
					// console.log('Se cambia '+element.sequence+' por '+i);
					element.sequence = i;
				});

			this.modal_eventos_masiv = false;
			this.modal_events_masiv = true;
			
		},
		confirmarEventsTipoDespacho(data,index){
			const eventoInvalido = data.eventos.find(element => element.time < 5 || element.time == '' || element.time == null);

			if (eventoInvalido) {
				this.loader_even = false;
				this.$toast.add({
					severity: 'error',
					summary: 'Error',
					detail: `El evento ${eventoInvalido.event} tiene tiempo en menor a 5 minutos`,
					life: 4000
				});
				return; // Sale del método y NO hace la petición
			}
			this.eventos[index].editable = false;
		},
		guardar_events_default(){
			this.loader_even = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			// this.json_events_masiv.forEach(element => {
			// 	if (element.time == 0) {
			// 		this.$toast.add({severity:'error', summary: 'Error', detail:'El evento '+element.event+' tiene tiempo en 0 minutos', life: 4000});
			// 		return;
			// 	}
			// }); 
			const eventoInvalido = this.json_events_masiv.find(element => element.time < 5 || element.time == '' || element.time == null);

			if (eventoInvalido) {
				this.loader_even = false;
				this.$toast.add({
					severity: 'error',
					summary: 'Error',
					detail: `El evento ${eventoInvalido.event} tiene tiempo en menor a 5 minutos`,
					life: 4000
				});
				return; // Sale del método y NO hace la petición
			}
			console.log(this.json_events_masiv);
			
			window.api.call('post', '/guardar_eventos_masivos', {email: email,id_rol: id_rol,eventos: this.json_events_masiv}).then( function(response) {
				if(response.status == 200){
					_that.modal_events_masiv = false;
					_that.json_events_masiv = [];
					// _that.modal_config = false;
					_that.events_default = response.data.data;
					// _that.cargargeneradorescustomer(_that.pagination.current_page);
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se Guardo los eventos con exito', life: 6000 });
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader_even = false;
				if(err.status == 424){
					_that.$toast.add({severity:'error', summary: 'Error', detail:err.data.message, life: 4000});
				}
			});
		},
		traerindicadores(data){
			if(data){
				// console.log(data);
				this.cargargeneradorescustomer(1);
			}else{
				// console.log('deseleccionado');
			}
		},
		openModalConfig(data){
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			this.loader_table = true;
			this.customers = [];
			this.nit_generador = '';
			this.checkboxValue = [];
			this.list_tdespachos_selected = [];
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			window.api.call('post', '/tipos_despachos_customers', {email: email,id_rol: id_rol,nit_generador: data.documento}).then( function(response) {
				if(response.status == 200){
					_that.modal_config = true;
					_that.nit_generador = data.documento;
					_that.loader_table = false;
					_that.tipos_despachos = response.data.data;
					_that.list_tdespachos_selected = response.data.p_configurables;
					response.data.p_configurables.forEach(element => {
						var tipos_despachos_sele =  _that.tipos_despachos.find((gen_seway) => gen_seway.seway_tdespacho == element.code_type_dispatch)
						if (tipos_despachos_sele!=null) { 
							// _that.checkboxValue.push(element);
							_that.checkboxValue.push({
								idtipo_despachos: tipos_despachos_sele.idtipo_despachos,
								// id: element.id,
								descripcion: tipos_despachos_sele.descripcion,
								seway_tdespacho: tipos_despachos_sele.seway_tdespacho
							});
						}
					});
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se trajo los tipos despachos con exito', life: 6000 });
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader_table = false;
			});
		},
		openModalEents(data,index){
			// console.log(data);
			// var _that = this;
			this.checkEvents = [];
			this.list_events = [];
			this.modal_eventos = true;
			this.modal_events = false;
			this.openmasiv = false;
			this.list_events = data;
			this.list_events.index = index;
			this.list_events.todos_eventos.forEach(element => {
				var eventos_sele =  this.list_events.eventos.find((evento) => evento.code == element.code)
				if (eventos_sele!=null) { 
					// console.log(eventos_sele);
					// this.checkEvents.push(eventos_sele.code);
					this.checkEvents.push({
						code: eventos_sele.code,
						event: eventos_sele.event,
						// id: eventos_sele.id,
						id_events: element.id_events
					});
				}
			});
		},
		openpermisionmasiv(){
			var masivpermision = false;
			this.eventos.forEach(evento => {
						if (evento.estado_tipo_despacho==false) {
							masivpermision = true;
							this.openmasiv = true;
						}
					// _that
					});
					return masivpermision;
		},
		openModalEventsMasiv(){
			this.modal_eventos = true;
			this.modal_events = false;
			this.checkEvents = [];
			this.checkEvents.push({
				code: 5,
				event: "INICIAR VIAJE",
				// id: eventos_sele.id,
				id_events: 5
			});
			// console.log(this.eventos);
		},
		showEvents(){
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			this.loader_even = true;
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.openmasiv = false;
			this.eventos = [];
			window.api.call('post', '/eventos_tipo_despachos', {email: email,id_rol: id_rol,json_tipodespachos: this.checkboxValue,nit_generador: this.nit_generador}).then( function(response) {
				if (response.status == 200) {
				_that.modal_events = true;
				_that.modal_config = false;

				const eventosData = Object.values(response.data.data); // 👈 aquí el fix

				_that.eventos = eventosData;

				eventosData.forEach(evento_r => {
					if (Array.isArray(evento_r.eventos)) {
						evento_r.eventos.forEach(evento => {
							if (evento.confirmation == 1) {
								evento.confirmation = true;
							}
							if (evento.validate_geocerca == 1) {
								evento.validate_geocerca = true;
							}
							if (evento.allow_automatic == 1) {
								evento.allow_automatic = true;
							}
						});
					}
					if (evento_r.estado_tipo_despacho == false) {
						_that.list_events = evento_r;
						_that.openmasiv = true;
					}
				});

				_that.loader_even = false;
				_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se trajo los eventos con éxito', life: 6000 });
			}
			}).catch(function (err) {
				console.log(err);
				_that.loader_even = false;
			});
		},
		guardar_eventos(){
			this.loader_even = true;
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			// console.log(' pag actual '+this.pagination.current_page);
			
			window.api.call('post', '/guardar_eventos', {email: email,id_rol: id_rol,eventos: this.eventos,nit_generador: this.nit_generador}).then( function(response) {
				if(response.status == 200){
					_that.modal_events = false;
					_that.modal_config = false;
					// _that.eventos = response.data.data
					_that.cargargeneradorescustomer(_that.pagination.current_page);
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Se Guardo los eventos con exito', life: 6000 });
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader_even = false;
				if(response.status == 424){
					_that.$toast.add({severity:'error', summary: 'Error', detail:err.data.message, life: 4000});
				}
			});
		},
		limpiar(){
			this.selectgenerador = null;
			this.cargargeneradorescustomer(1);

		},
		openModalDeleteTipoDespacho(data,index){
			// console.log(data);
			// console.log(index);
			
			if (data.estado_tipo_despacho==false) {
				this.checkboxValue.splice(index,1);
				this.eventos.splice(index,1);
				this.$toast.add({severity:'success', summary: 'Eliminado correctamente', detail:'Los Tipos de despacho con estado Sin Guardar se eliminan sin confirmación', life: 5000});
				// this.modal_events = false;
				
				// this.showEvents();

			}else{
				localStorage.setItem('types_dispatches_clients_id',data.types_dispatches_clients_id);
				localStorage.setItem('idx_tipo_despacho',index);
				this.deleteTipoDespachoDialog = true;
				// localStorage.getItem("idx_factura_elimiada")
			}
			
		},
		eliminar_evento(data,index,index_eventos){
			if (data.id==0) {
				this.eventos[index_eventos].eventos.splice(index,1);
				this.$toast.add({severity:'success', summary: 'Eliminado correctamente', detail:'Los Eventos con estado Sin Guardar se eliminan sin confirmación', life: 5000});

				this.eventos[index_eventos].eventos = this.eventos[index_eventos].eventos.sort((a, b) => a.id_events - b.id_events);
				var i = 0
				this.eventos[index_eventos].eventos.forEach(element => {
						i = i+1;
						// console.log('Se cambia '+element.sequence+' por '+i);
						element.sequence = i;
					});

			}else{
				localStorage.setItem('id_event',data.id);
				localStorage.setItem('idx_tipo_despacho',index);
				localStorage.setItem('idx_evento',index_eventos);
				this.deleteEventDialog = true;
				// localStorage.getItem("idx_factura_elimiada")
			}
			
		},
		eliminar_evento_masiv(data,index){
			if (data.id==0) {
				this.checkEventsMasiv.splice(index,1);
				this.json_events_masiv.splice(index,1);
				this.$toast.add({severity:'success', summary: 'Eliminado correctamente', detail:'Los Eventos con estado Sin Guardar se eliminan sin confirmación', life: 5000});

				this.json_events_masiv = this.json_events_masiv.sort((a, b) => a.id_events - b.id_events);
				var i = 0
				this.json_events_masiv.forEach(element => {
						i = i+1;
						// console.log('Se cambia '+element.sequence+' por '+i);
						element.sequence = i;
					});

			}else{
				localStorage.setItem('id_event_masiv',data.id);
				localStorage.setItem('index_masiv',index);
				// localStorage.setItem('idx_evento',index_eventos);
				this.deleteEventDialogMasiv = true;
				// localStorage.getItem("idx_factura_elimiada")
			}
		},
		deleteEventTipoDespach(){
			const types_dispatches_clients_id = localStorage.getItem("types_dispatches_clients_id");
			const idx_evento = localStorage.getItem("idx_tipo_despacho");
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.loader_even = true;
			window.api.call('post', '/eliminar_tipodespacho', {email: email,id_rol: id_rol,types_dispatches_clients_id: types_dispatches_clients_id,nit_generador: this.nit_generador}).then( function(response) {
				if(response.status == 200){
					_that.checkboxValue.splice(idx_evento,1);
					_that.eventos.splice(idx_evento,1);
					_that.deleteTipoDespachoDialog = false;
					// _that.modal_events = false;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Eliminado correctamente', detail: 'Puedes volver agregarlo en cualquier momento', life: 6000 });
				}
			}).catch(function (err) {
				console.log(err);
				_that.deleteEventDialog = false;
				_that.loader_even = false;
			});
		},
		deleteEvent(){
			const id_event = localStorage.getItem("id_event");
			const idx_tipo_despacho = localStorage.getItem("idx_tipo_despacho");
			const idx_evento = localStorage.getItem("idx_evento");
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.loader_even = true;
			window.api.call('post', '/eliminar_eventos', {email: email,id_rol: id_rol,id_event: id_event,nit_generador: this.nit_generador}).then( function(response) {
				if(response.status == 200){
					_that.eventos[idx_evento].eventos.splice(idx_tipo_despacho,1);
					_that.deleteEventDialog = false;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Eliminado correctamente', detail: 'Puedes volver agregarlo en cualquier momento', life: 6000 });
					_that.eventos[idx_evento].eventos = _that.eventos[idx_evento].eventos.sort((a, b) => a.id_events - b.id_events);
					var i = 0
					_that.eventos[idx_evento].eventos.forEach(element => {
						i = i+1;
						// console.log('Se cambia '+element.sequence+' por '+i);
						element.sequence = i;
					});
				}
			}).catch(function (err) {
				console.log(err);
				_that.deleteEventDialog = false;
				_that.loader_even = false;
			});
		},
		deleteEventMasiv(){
			const id_event_masiv = localStorage.getItem("id_event_masiv");
			const index_masiv = localStorage.getItem("index_masiv");
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
			this.loader_even = true;
			window.api.call('post', '/eliminar_eventos_masivos', {email: email,id_rol: id_rol,id_event: id_event_masiv,nit_generador: this.nit_generador}).then( function(response) {
				if(response.status == 200){
					_that.json_events_masiv.splice(index_masiv,1);
					_that.checkEventsMasiv.splice(index_masiv,1);
					// _that.checkEventsMasiv = response.data.array_events;
					// _that.eventos_configurados_masiv = response.data.response;
					_that.events_default = response.data.data;
					_that.deleteEventDialogMasiv = false;
					_that.loader_even = false;
					_that.$toast.add({ severity: 'success', summary: 'Eliminado correctamente', detail: 'Puedes volver agregarlo en cualquier momento', life: 6000 });
					_that.json_events_masiv = _that.json_events_masiv.sort((a, b) => a.id_events - b.id_events);
					var i = 0
					_that.json_events_masiv.forEach(element => {
						i = i+1;
						// console.log('Se cambia '+element.sequence+' por '+i);
						element.sequence = i;
					});
				}
			}).catch(function (err) {
				console.log(err);
				_that.deleteEventDialogMasiv = false;
				_that.loader_even = false;
			});
		},
		cleartable(){
			
			this.pagination.current_page = 0;
				this.pagination.from= 0;
				this.pagination.last_page= 0;
				this.pagination.per_page= 0;
				this.pagination.to= 0;
				this.pagination.total= 0;
		},
		onChangePage(page) {
			this.cargargeneradorescustomer(page.page+1);
		},
		cargargeneradorescustomer(page){
			this.seway_exist = true;
			const cookieName = 'Email';
				const IdRol = 'IdRol';
				this.loader = true;
				this.customers = [];
				let cookie = {};
				document.cookie.split(';').forEach(function(el) {
				let [key,value] = el.split('=');
				cookie[key.trim()] = value;
				})
				var email = cookie[cookieName];
				var id_rol = cookie[IdRol];
			// this.cleartable();
			// console.log('page '+page);
			this.loader = true;
			var _that = this;
			this.generadores_table = [];
			this.checkEventsMasiv = [];
			this.events_default = [];
			this.eventos_configurados_masiv = [];
			window.api.call('post', '/cargar_generadores_customers?&page='+page, {email: email,id_rol: id_rol,selectgenerador: this.selectgenerador}).then( function(response) {
				if(response.status == 200){
					_that.pagination = response.data.data;
					// console.log(response.data.data);
					if (response.data.exist_seway>0) {
						_that.seway_exist = true;
					}else{
						_that.seway_exist = false;
					}
					_that.loader = false;
					
					_that.generadores = response.data.generadores;
					_that.generadores_seway = response.data.generadores_seway;
					_that.generadores_table = response.data.data.data;
					_that.eventos_configurados_masiv = response.data.eventos_configurados_masiv;
					_that.checkEventsMasiv = response.data.array_events;
					_that.events_default = response.data.events_masiv_config_customer;
					_that.$refs.op.hide();
					// console.log(_that.pagination.current_page);
					// console.log(_that.pagination);
						
				}
			}).catch(function (err) {
				console.log(err);
				_that.loader = false;
			});
		},
		salirCustomer(){
			this.ingresoCostumer = false;
		},
	},
	computed: {
			menuSize() {
                // Verifica el tamaño del dispositivo
                if (window.innerWidth >= this.$primevue.config.breakpoints.md) {
                    // Para dispositivos lg y más grandes
                    return this.modalAmplio;
                } else {
                    // Para dispositivos más pequeños que lg
                    return this.modalResponsive;
                }
            },
			isRTL() {
				return this.$appState.RTL;
			}
		}
}
</script>

<style scoped lang="scss">
$navy:#0A354E; $orange:#EB7D10; $white:#fff;
$g200:#e8eaed; $g500:#6b7280; $g700:#374151; $r:16px; $bg:#f7f7f7;

.ev-wrap { background:$bg; min-height:100vh; padding:1.25rem .5rem; }

/* ── Sin app ── */
.ev-empty-app { display:flex; flex-direction:column; align-items:center; justify-content:center; min-height:60vh; text-align:center; padding:2rem; }
.ev-empty-title { font-size:1.2rem; font-weight:700; color:$g700; margin:0 0 .5rem; }
.ev-empty-sub   { font-size:.875rem; color:$g500; margin:0 0 1.5rem; }
.ev-btn-whatsapp { display:inline-flex; align-items:center; gap:.4rem; background:#16a34a; color:#fff; border:none; border-radius:8px; padding:.55rem 1.25rem; font-size:.85rem; font-weight:600; cursor:pointer; &:hover{background:#15803d;} i{font-size:14px;} }

/* ── Topbar ── */
.ev-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:1.25rem; flex-wrap:wrap; gap:.75rem; }
.ev-title  { font-size:1.35rem; font-weight:700; color:$g700; margin:0 0 .2rem; }
.ev-sub    { font-size:.8rem; color:$g500; margin:0; }
.ev-topbar-actions { display:flex; gap:.65rem; }

/* ── Buttons ── */
.ev-btn-primary { display:inline-flex; align-items:center; gap:.35rem; background:$navy; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:background .15s; i{font-size:13px;} &:hover{background:#0c4f77;} &:disabled{opacity:.6;cursor:not-allowed;} }
.ev-btn-outline  { display:inline-flex; align-items:center; gap:.35rem; background:$white; color:$g700; border:1px solid $g200; border-radius:8px; padding:.45rem .9rem; font-size:.82rem; font-weight:600; cursor:pointer; transition:all .15s; i{font-size:13px;} &:hover{border-color:$navy;color:$navy;} }
.ev-btn-danger   { display:inline-flex; align-items:center; gap:.35rem; background:#dc2626; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{background:#b91c1c;} &:disabled{opacity:.6;cursor:not-allowed;} }
.ev-btn-orange   { display:inline-flex; align-items:center; gap:.35rem; background:$orange; color:#fff; border:none; border-radius:8px; padding:.45rem 1rem; font-size:.82rem; font-weight:600; cursor:pointer; &:hover{background:#d56400;} i{font-size:13px;} }

.ev-btn-icon { display:inline-flex; align-items:center; justify-content:center; width:30px; height:30px; background:$white; border:1px solid $g200; border-radius:6px; cursor:pointer; color:$g700; font-size:.8rem; transition:all .15s; &:hover{border-color:$navy;color:$navy;} &:disabled{opacity:.5;cursor:not-allowed;} }
.ev-btn-icon--danger { &:hover{border-color:#dc2626;color:#dc2626;} }

.ev-btn-sm { display:inline-flex; align-items:center; gap:.3rem; border:none; border-radius:6px; padding:.3rem .75rem; font-size:.75rem; font-weight:600; cursor:pointer; i{font-size:11px;} }
.ev-btn-sm--primary { background:$navy; color:#fff; &:hover{background:#0c4f77;} }
.ev-btn-sm--success { background:#16a34a; color:#fff; &:hover{background:#15803d;} }

/* ── Filtros ── */
.ev-filtros { padding:.25rem; }
.ev-filtros-title { display:flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:700; color:$navy; padding-bottom:.75rem; border-bottom:1px solid $g200; margin-bottom:.875rem; i{font-size:14px;} }
.ev-filtros-field { display:flex; flex-direction:column; gap:.3rem; margin-bottom:.875rem; label{font-size:.72rem;font-weight:700;color:$g500;text-transform:uppercase;letter-spacing:.5px;} }
.ev-filtros-actions { display:flex; justify-content:flex-end; padding-top:.75rem; border-top:1px solid $g200; }

/* ── Tabla base ── */
.ev-tabla-wrap { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.ev-tabla { width:100%; border-collapse:collapse; font-size:.82rem; }
.ev-tabla thead tr { background:#f8f9fa; }
.ev-tabla th { text-align:left; padding:.65rem 1rem; font-size:.63rem; font-weight:700; letter-spacing:.7px; text-transform:uppercase; color:$g500; border-bottom:1px solid $g200; white-space:nowrap; }
.ev-tabla td { padding:.65rem 1rem; border-bottom:1px solid #f1f3f4; color:$g700; vertical-align:middle; }
.ev-tabla tbody tr:last-child td { border-bottom:none; }
.ev-tabla tbody tr:hover td { background:#fafbfc; }
.ev-tabla--events th, .ev-tabla--events td { padding:.5rem .65rem; }

/* Celdas tabla generadores */
.ev-nit      { font-size:.78rem; font-family:monospace; font-weight:600; color:$g500; }
.ev-gen-name { font-weight:600; font-size:.83rem; color:$g700; }

/* Tabla eventos */
.ev-event-name { font-weight:500; font-size:.8rem; white-space:nowrap; }
.ev-seq   { display:inline-flex; align-items:center; justify-content:center; width:24px; height:24px; background:#eff6ff; color:#1e40af; font-size:.72rem; font-weight:700; border-radius:50%; }
.ev-num   { font-size:.8rem; font-variant-numeric:tabular-nums; }
.ev-num--dim { color:$g500; }
.ev-row--inactive td { opacity:.5; }

.ev-input-num { :deep(.p-inputnumber-input){ width:70px; text-align:center; font-size:.78rem; padding:.3rem .4rem; } }

/* ── Badges ── */
.ev-badge { display:inline-flex; align-items:center; gap:.3rem; font-size:.68rem; font-weight:700; padding:.18rem .6rem; border-radius:20px; white-space:nowrap; }
.ev-badge--verde   { background:#f0fdf4; color:#166534; }
.ev-badge--naranja { background:#fff7ed; color:#9a3412; }
.ev-badge--azul    { background:#eff6ff; color:#1e40af; }
.ev-badge--gris    { background:#f1f5f9; color:#64748b; }

/* ── Paginación ── */
.ev-pagination { display:flex; justify-content:space-between; align-items:center; padding:.75rem 1rem; border-top:1px solid $g200; font-size:.78rem; color:$g500; }
.ev-paginator  { background:transparent; border:none; }

/* ── Empty / skeleton ── */
.ev-empty { text-align:center; padding:3rem !important; color:$g500; i{font-size:1.75rem;display:block;margin-bottom:.75rem;} p{font-size:.875rem;} }
@keyframes shimmer { 0%{background-position:-600px 0} 100%{background-position:600px 0} }
.ev-skeleton-wrap { padding:1rem; }
.ev-skeleton-row  { height:56px; border-radius:8px; background:linear-gradient(90deg,#ececec 25%,#f5f5f5 50%,#ececec 75%); background-size:1200px; animation:shimmer 1.4s infinite linear; margin-bottom:.5rem; }

/* ── Modales ── */
.ev-dialog {
  :deep(.p-dialog-header) { font-weight:700; font-size:1rem; border-bottom:1px solid $g200; }
  :deep(.p-dialog-content){ padding:1.5rem; }
  :deep(.p-dialog-footer) { border-top:1px solid $g200; padding:1rem 1.5rem; display:flex; justify-content:flex-end; gap:.65rem; }
}
.ev-dialog--wide {
  :deep(.p-dialog-content){ padding:1.25rem; }
}

.ev-modal-body { display:flex; flex-direction:column; gap:1rem; }
.ev-modal-events-header { display:flex; justify-content:space-between; align-items:center; width:100%; }
.ev-modal-events-title  { font-size:1rem; font-weight:700; color:$g700; }
.ev-modal-events-sub    { font-size:.78rem; color:$g500; margin-top:2px; }

/* Tipos de despacho lista */
.ev-check-all { display:flex; align-items:center; gap:.5rem; font-size:.82rem; font-weight:600; color:$g700; padding:.5rem 0; }
.ev-tipos-lista { display:flex; flex-direction:column; gap:.35rem; }
.ev-tipo-item { display:flex; align-items:center; gap:.65rem; padding:.6rem .875rem; border:1px solid $g200; border-radius:8px; cursor:pointer; transition:all .15s; &:hover{border-color:#93c5fd;background:#f8faff;} }
.ev-tipo-item--on { background:#f0f9ff; border-color:#7dd3fc; }
.ev-tipo-label { font-size:.83rem; font-weight:500; color:$g700; cursor:pointer; flex:1; }

/* Eventos check lista */
.ev-eventos-check-lista { display:flex; flex-direction:column; gap:.35rem; }
.ev-check-item { display:flex; align-items:center; gap:.65rem; padding:.6rem .875rem; border:1px solid $g200; border-radius:8px; cursor:pointer; transition:all .15s; &:hover{border-color:#93c5fd;background:#f8faff;} }
.ev-check-item--on { background:#f0fdf4; border-color:#86efac; }
.ev-check-label { font-size:.83rem; font-weight:500; color:$g700; cursor:pointer; flex:1; display:flex; align-items:center; }

/* Bloque tipo despacho */
.ev-eventos-container { display:flex; flex-direction:column; gap:1rem; }
.ev-evento-bloque { background:$white; border:1px solid $g200; border-radius:$r; overflow:hidden; }
.ev-bloque-header { display:flex; justify-content:space-between; align-items:center; padding:.875rem 1.25rem; background:#f8f9fa; border-bottom:1px solid $g200; flex-wrap:wrap; gap:.75rem; }
.ev-bloque-left { display:flex; align-items:center; gap:.75rem; }
.ev-bloque-icon { width:34px; height:34px; border-radius:8px; background:#eff6ff; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:15px;color:#1e40af;} }
.ev-bloque-title { font-size:.9rem; font-weight:700; color:$g700; }
.ev-bloque-sub   { font-size:.72rem; color:$g500; margin-top:1px; }
.ev-bloque-actions { display:flex; align-items:center; gap:.5rem; flex-wrap:wrap; }

/* Mensajes */
.ev-info-msg { display:flex; align-items:flex-start; gap:.5rem; background:#eff6ff; border:1px solid #bfdbfe; border-radius:8px; padding:.65rem .875rem; font-size:.8rem; color:#1e40af; i{font-size:13px;margin-top:1px;flex-shrink:0;} }
.ev-warn-msg { display:flex; align-items:flex-start; gap:.5rem; background:#fef3c7; border:1px solid #fcd34d; border-radius:8px; padding:.65rem .875rem; font-size:.8rem; color:#92400e; i{font-size:13px;margin-top:1px;flex-shrink:0;} }

/* Confirmar */
.ev-confirm-body    { display:flex; align-items:flex-start; gap:1rem; padding:.5rem; }
.ev-confirm-icon    { width:48px; height:48px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; i{font-size:1.3rem;} }
.ev-confirm-icon--danger { background:#fef2f2; i{color:#dc2626;} }
.ev-confirm-q   { font-size:.9rem; font-weight:600; color:$g700; margin:0 0 .35rem; }
.ev-confirm-sub { font-size:.82rem; color:$g500; margin:0; line-height:1.4; }

/* Responsive */
@media(max-width:768px) {
  .ev-bloque-header { flex-direction:column; align-items:flex-start; }
  .ev-topbar { flex-direction:column; align-items:flex-start; }
}
</style>
